import { CheckCircleOutline } from '@mui/icons-material'
import { Alert, AlertColor, AlertTitle, Box, useTheme } from '@mui/material'
import { ReactNode } from 'react'
import { useAppSelector } from '../../redux/hooks'
import { AlertIcon } from './AppAlertIcon'

export type AppAlertJSON = {
  id: number
  severity: AlertColor
  message: string
  title?: string
  icon?: AlertIcon
}

export class AppAlert {
  public id: number
  public title?: string
  public icon?: AlertIcon = undefined
  
  constructor(
    public severity: AlertColor,
    public message: string,
  ) {
    const now = new Date()
    this.id = now.getTime()
  }

  withTitle = (title: string): AppAlert => {
    this.title = title
    return this
  }

  withIcon = (icon: AlertIcon): AppAlert => {
    this.icon = icon
    return this
  }

  toJSON = (): AppAlertJSON => {
    return {
      id: this.id,
      severity: this.severity,
      message: this.message,
      title: this.title,
      icon: this.icon
    }
  }
}

export const AppAlerts = () => {

  const alerts = useAppSelector(state => state.alerts.alerts)
  const theme = useTheme()

  const getIcon = (x: AlertIcon | undefined): ReactNode | undefined => {
    if (x === AlertIcon.Check) {
      return <CheckCircleOutline />
    }
    return undefined
  }

  return (
    <Box sx={{ position: 'fixed', bottom: theme.spacing(2), right: theme.spacing(3), zIndex: 1400 }}>
      {alerts.map(a =>
        <Alert key={a.message} icon={getIcon(a.icon)} severity={a.severity}>
          {a.title ? <AlertTitle>{a.title}</AlertTitle> : null }
          <Box>{a.message}</Box>
        </Alert>)
      }
    </Box>
  )
}